import { render, staticRenderFns } from "./bulma_tabbar.vue?vue&type=template&id=0b77dd87&scoped=true&lang=html"
import script from "./bulma_tabbar.vue?vue&type=script&lang=js"
export * from "./bulma_tabbar.vue?vue&type=script&lang=js"
import style0 from "./bulma_tabbar.vue?vue&type=style&index=0&id=0b77dd87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b77dd87",
  null
  
)

export default component.exports